export const routes = [
  {
    path: "/cidade-empreendedora-news",
    name: "cidade-empreendedora-news.editor",
    component: () =>
      import(
        /* webpackChunkName: "cidade-empreendedora-news" */ "./components/Editor.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },
];
